import React from "react";
import { useQuery } from "@apollo/react-hooks";

import { ApolloProvider } from "@apollo/react-hooks";
import { apolloClient } from "../../apollo/apollo-client";

import { GET_PHOTOS_BY_CREATOR } from "./queries";

import { Loading } from "../shared";
import { PhotoResultRowGrid } from "../PhotoResultRowGrid";

import styled from "styled-components";

export const OldGridContainer = styled.div`
    max-width: 964px;
`;

export const ProfilePhotos = ({ creator }) => {
    const { loading, data } = useQuery(GET_PHOTOS_BY_CREATOR, {
        variables: {
            creator: creator,
            limit: 12
        },
        skip: !creator,
        fetchPolicy: "cache-and-network"
    });

    if (loading) {
        return <Loading />;
    }

    const isSubscribed = true; // Don't show ads

    if (data && data.browsePhotosByCreator) {
        return (
            <PhotoResultRowGrid
                results={data.browsePhotosByCreator}
                useRouterLink={false}
                subscribed={isSubscribed}
                maxRows={3}
            ></PhotoResultRowGrid>
        );
    }
    return null;
};

// This component will be embedded in a Django template for now, so it needs
// its own ApolloProvider.
export const ProfilePhotosWrapper = ({ args: { creator } }) => {
    // Use className="container" to pick up styles from the old grid.
    return (
        <ApolloProvider client={apolloClient}>
            <OldGridContainer className="container">
                <ProfilePhotos creator={creator} />
            </OldGridContainer>
        </ApolloProvider>
    );
};

export default ProfilePhotosWrapper;
